import $ from 'jquery';

const endpoint = 'https://www.rcsdk8.org/rcsd/feed/schools';

export default class Schools {
  constructor(element) {
    this.$element = $(element);
    // Set context
    this.done = this.done.bind(this);
    this.click = this.click.bind(this);
    // Fire off request
    this.request = $.ajax(this.settings);
    this.request.done(this.done);
  }

  done(results) {
    if (results.length) {
      this.$menu = results;
      this.listen();
    }
  }

  listen() {
    this.$button.on('click', this.click);
  }

  click() {
    this.$element.toggleClass('show');
  }

  get $button() {
    return this.$element.find('button');
  }

  get $menu() {
    return this.$element.find('nav');
  }

  // eslint-disable-next-line class-methods-use-this
  set $menu(results) {
    const $list = $('<ul/>');
    results.forEach((result) => {
      const path = '/sites/default/themes/dtheme/img/logos/';
      const filename = result.name.toLowerCase().replace(/\s/g, '-');
      $list.append(`<li class="${filename}"><a href="${result.destination}"><img src="${path}${filename}.png">${result.name}</a></li>`);
    });
    $list.insertAfter(this.$button);
    $list.wrap('<nav/>');
  }

  // eslint-disable-next-line class-methods-use-this
  get settings() {
    return {
      url: endpoint,
      cache: false,
      method: 'get',
      dataType: 'json',
    };
  }
}



// WEBPACK FOOTER //
// ./SchoolsMenu.js